import { render, staticRenderFns } from "./ModalAddCompany.vue?vue&type=template&id=5da15490"
import script from "./ModalAddCompany.vue?vue&type=script&lang=js"
export * from "./ModalAddCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports